import React, { useState, useEffect } from 'react';
import '../../styles/components.css';

const ProductoForm = ({ producto = null, onSubmit, onCancel, loading = false }) => {
  const [formData, setFormData] = useState({
    codigo: '',
    nombre: '',
    descripcion: '',
    categoria: '',
    precio: '',
    stock_actual: '',
    stock_minimo: '',
    laboratorio: '',
    requiere_receta: false,
    activo: true
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (producto) {
      setFormData({
        codigo: producto.codigo || '',
        nombre: producto.nombre || '',
        descripcion: producto.descripcion || '',
        categoria: producto.categoria || '',
        precio: producto.precio || '',
        stock_actual: producto.stock_actual || '',
        stock_minimo: producto.stock_minimo || '',
        laboratorio: producto.laboratorio || '',
        requiere_receta: producto.requiere_receta || false,
        activo: producto.activo !== undefined ? producto.activo : true
      });
    }
  }, [producto]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Limpiar error del campo al escribir
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.codigo.trim()) {
      newErrors.codigo = 'El código es requerido';
    }

    if (!formData.nombre.trim()) {
      newErrors.nombre = 'El nombre es requerido';
    }

    if (!formData.categoria.trim()) {
      newErrors.categoria = 'La categoría es requerida';
    }

    if (!formData.precio || parseFloat(formData.precio) <= 0) {
      newErrors.precio = 'El precio debe ser mayor a 0';
    }

    if (!formData.stock_minimo || parseInt(formData.stock_minimo) < 0) {
      newErrors.stock_minimo = 'El stock mínimo debe ser mayor o igual a 0';
    }

    if (!producto && (!formData.stock_actual || parseInt(formData.stock_actual) < 0)) {
      newErrors.stock_actual = 'El stock actual debe ser mayor o igual a 0';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validate()) {
      return;
    }

    const dataToSubmit = {
      ...formData,
      precio: parseFloat(formData.precio),
      stock_actual: parseInt(formData.stock_actual),
      stock_minimo: parseInt(formData.stock_minimo)
    };

    onSubmit(dataToSubmit);
  };

  return (
    <form onSubmit={handleSubmit} className="producto-form">
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="codigo" className="form-label required">
            Código
          </label>
          <input
            type="text"
            id="codigo"
            name="codigo"
            className={`form-control ${errors.codigo ? 'is-invalid' : ''}`}
            value={formData.codigo}
            onChange={handleChange}
            disabled={loading || !!producto}
            placeholder="Ej: MED001"
          />
          {errors.codigo && <div className="invalid-feedback">{errors.codigo}</div>}
        </div>

        <div className="form-group">
          <label htmlFor="nombre" className="form-label required">
            Nombre
          </label>
          <input
            type="text"
            id="nombre"
            name="nombre"
            className={`form-control ${errors.nombre ? 'is-invalid' : ''}`}
            value={formData.nombre}
            onChange={handleChange}
            disabled={loading}
            placeholder="Nombre del producto"
          />
          {errors.nombre && <div className="invalid-feedback">{errors.nombre}</div>}
        </div>

        <div className="form-group">
          <label htmlFor="categoria" className="form-label required">
            Categoría
          </label>
          <select
            id="categoria"
            name="categoria"
            className={`form-control ${errors.categoria ? 'is-invalid' : ''}`}
            value={formData.categoria}
            onChange={handleChange}
            disabled={loading}
          >
            <option value="">Seleccionar categoría</option>
            <option value="Medicamentos">Medicamentos</option>
            <option value="Genéricos">Genéricos</option>
            <option value="Vitaminas">Vitaminas</option>
            <option value="Cuidado Personal">Cuidado Personal</option>
            <option value="Primeros Auxilios">Primeros Auxilios</option>
            <option value="Otros">Otros</option>
          </select>
          {errors.categoria && <div className="invalid-feedback">{errors.categoria}</div>}
        </div>

        <div className="form-group">
          <label htmlFor="laboratorio" className="form-label">
            Laboratorio
          </label>
          <input
            type="text"
            id="laboratorio"
            name="laboratorio"
            className="form-control"
            value={formData.laboratorio}
            onChange={handleChange}
            disabled={loading}
            placeholder="Nombre del laboratorio"
          />
        </div>

        <div className="form-group">
          <label htmlFor="precio" className="form-label required">
            Precio
          </label>
          <input
            type="number"
            id="precio"
            name="precio"
            className={`form-control ${errors.precio ? 'is-invalid' : ''}`}
            value={formData.precio}
            onChange={handleChange}
            disabled={loading}
            placeholder="0.00"
            step="0.01"
            min="0"
          />
          {errors.precio && <div className="invalid-feedback">{errors.precio}</div>}
        </div>

        <div className="form-group">
          <label htmlFor="stock_actual" className="form-label required">
            Stock Actual
          </label>
          <input
            type="number"
            id="stock_actual"
            name="stock_actual"
            className={`form-control ${errors.stock_actual ? 'is-invalid' : ''}`}
            value={formData.stock_actual}
            onChange={handleChange}
            disabled={loading || !!producto}
            placeholder="0"
            min="0"
          />
          {errors.stock_actual && <div className="invalid-feedback">{errors.stock_actual}</div>}
          {producto && <small className="form-text">El stock se modifica desde Inventario</small>}
        </div>

        <div className="form-group">
          <label htmlFor="stock_minimo" className="form-label required">
            Stock Mínimo
          </label>
          <input
            type="number"
            id="stock_minimo"
            name="stock_minimo"
            className={`form-control ${errors.stock_minimo ? 'is-invalid' : ''}`}
            value={formData.stock_minimo}
            onChange={handleChange}
            disabled={loading}
            placeholder="0"
            min="0"
          />
          {errors.stock_minimo && <div className="invalid-feedback">{errors.stock_minimo}</div>}
        </div>

        <div className="form-group form-group-full">
          <label htmlFor="descripcion" className="form-label">
            Descripción
          </label>
          <textarea
            id="descripcion"
            name="descripcion"
            className="form-control"
            value={formData.descripcion}
            onChange={handleChange}
            disabled={loading}
            placeholder="Descripción del producto"
            rows="3"
          />
        </div>

        <div className="form-group">
          <div className="form-check">
            <input
              type="checkbox"
              id="requiere_receta"
              name="requiere_receta"
              className="form-check-input"
              checked={formData.requiere_receta}
              onChange={handleChange}
              disabled={loading}
            />
            <label htmlFor="requiere_receta" className="form-check-label">
              Requiere Receta Médica
            </label>
          </div>
        </div>

        <div className="form-group">
          <div className="form-check">
            <input
              type="checkbox"
              id="activo"
              name="activo"
              className="form-check-input"
              checked={formData.activo}
              onChange={handleChange}
              disabled={loading}
            />
            <label htmlFor="activo" className="form-check-label">
              Producto Activo
            </label>
          </div>
        </div>
      </div>

      <div className="form-actions">
        <button
          type="button"
          className="btn btn-outline-danger"
          onClick={onCancel}
          disabled={loading}
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading}
        >
          {loading ? 'Guardando...' : (producto ? 'Actualizar' : 'Crear')} Producto
        </button>
      </div>
    </form>
  );
};

export default ProductoForm;

// Made with Bob
